import React,{useState} from 'react';
import '../Styles/GroupQuery.css';

const GroupQuery = () => {
  const [notes, setNotes] = useState(['']); // Initialize with one note

  const addNote = () => {
    setNotes([...notes, '']); // Add a new empty note
  };

  return (
    <div>
      
      <div className="groupquery-main">
        <div className="groupquery-radio">
          <label>
            <input type="radio" name="tripType" value="Oneway" />
            Oneway
          </label>
          <label>
            <input type="radio" name="tripType" value="RoundTrip" />
            Round Trip
          </label>
        </div>
        <div className="groupquery-form">
          <div>
            <label>Sector Onward</label>
            <input type="text" name="SectorOnward" placeholder='IXB-DEL'/>
          </div>
          <div>
            <label>Travel Date</label>
            <input type="date" name="TravelDate" placeholder='Travel Date'/>
          </div>
          <div>
            <label>No. of Pax</label>
            <input type="number" name="NoOfPax" placeholder='0'/>
          </div>
          <div>
            <label>Expected Fare</label>
            <input type="number" name="ExpectedFare" placeholder=''/>
          </div>
          <div>
            <label>Preferred Airline</label>
            <select name="Preferred Airline">
            <option >Any Airlines</option>
            <option >Airlines 1</option>
            <option>Airline 2</option>
           </select>
          </div>
          <div>
            <label>Contact Number</label>
            <input type="number" name="ContactNo" placeholder=''/>
          </div>
          <div>
            <label>Sector Return</label>
            <input type="text" name="SctorReturn" placeholder='DEL-IXB'/>
          </div>
          <div>
            <label>Travel Date</label>
            <input type="date" name="TravelDateR" placeholder='Travel Date'/>
          </div>
        </div>
        <div className="add-note-container">
          <button onClick={addNote} className="add-note-button">
            <span>+</span>
          </button><label>Add Note</label>
        </div>
        <div className="groupquery-submit-container">
          <button className="groupquery-submit">Submit</button>
        </div>
        <div className ="groupquery-table-title">GROUP HISTORY</div>
         <div className="groupquery-history">
          <input type ="date" name="groupStartDate" placeholder=''/> 
          <input type ="date" name="groupStartDate" placeholder=''/> 
          <select name="tripType" >
            <option>Trip Type</option>
            <option>Trip Type1</option>
            <option>Trip Type2</option>
          </select> 
          <select name="status" >
            <option>Status</option>
            <option>Status 1</option>
            <option>Status 2</option>
          </select> 
          <input type ="text" name="groupquerySearch" placeholder='Search'/>
         </div>
        <div className="groupquery-result-list">0 results found </div>
        <div className="groupquery-table">
          <table>
            <tr>
              <th>#ID</th>
              <th>Entry Date</th>
              <th>Status</th>
              <th>Trip-Type</th>
              <th>Onward</th>
              <th>Onward-Dates</th>
              <th>Return</th>
              <th>Return-Dates</th>
              <th>Pax</th>
              <th>Quotes</th>
              <th>Aspected</th>
              <th>Assigned</th>
              <th>Mobile</th>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </table>
        </div>
        
      </div>
    </div>
  )

};
export default GroupQuery;